// UploaderStore: wraps ChunkUploader with observable progress
import { makeAutoObservable, runInAction } from "mobx";
import ChunkUploader from "../components/ChunkUploader";

export class UploaderStore {
  constructor(uploadFn) {
    this._uploadFn = uploadFn; // (id, blob, onProgress) => Promise
    this.uploader = null;
    this.uploadTotal = 0;
    this.uploaded = 0;
    this.percent = null;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  attach(recordingId) {
    const upload = async (id, data, onUploadProgress) => {
      await this._uploadFn(id, data, onUploadProgress);
    };
    this.uploader = new ChunkUploader(upload);
    this.uploader.recordingId = recordingId;
    this.uploader.on('update', () => {
      const { uploadTotal, uploaded } = this.uploader;
      runInAction(() => {
        this.uploadTotal = uploadTotal;
        this.uploaded = uploaded;
        this.percent = (uploaded / (uploadTotal + Number.EPSILON)) * 100;
      });
    });
  }

  enqueue(blob) { this.uploader?.add(blob); }

  waitForDrain() { return new Promise(resolve => this.uploader?.isQueueEmpty ? resolve() : this.uploader?.on('ready', resolve)); }

  reset() { this.uploadTotal = 0; this.uploaded = 0; this.percent = null; this.uploader = null; }
}
